
import '../Welcome/Welcome.scss'
import WelcomeItem from "./components/WelcomeItem";



const Welcome = () =>{
return(
            <>
            <div className="welcome">
                <div className="welcome__container">
                    <h2 className="welcome__title">welcome to <span className="colored">U Store</span>, buy only proven and best used gadgets</h2>
                    <div className="welcome__item-wrap">
                        <WelcomeItem 
                        src='./img/cd.png' 
                        title='CHECK OUR CD COLLECTION'
                        text='Donec pede justo, fringilla vel, al, vulputate eget, arcu. In enim justo, lorem ipsum.'
                        backgroundColor='#1e1e20'/>
                        <WelcomeItem 
                        src='./img/headphone.png' 
                        title='LISTEN BEFORE PURCHASE'
                        text='Donec pede justo, fringilla vel, al, vulputate eget, arcu. In enim justo, lorem ipsum.'
                        backgroundColor='#cc3333'/>
                        <WelcomeItem 
                        src='./img/calender.png' 
                        title='UPCOMING EVENTS'
                        text='Donec pede justo, fringilla vel, al, vulputate eget, arcu. In enim justo, lorem ipsum.'
                        backgroundColor='#1e1e20'/>
                        
                    </div>
                    
                </div>
                
            </div>
            </>
        )
}


export default Welcome;